// Fonte única de verdade para o sistema de cores GCB PAS
// Figma: https://www.figma.com/design/EVNoIvOdB90RZfOGSBl3qM
// Importado por: tailwind.config.js e src/utils/colors.ts

module.exports = {
  primary: {
    lightest: '#B3B8C2',
    light: '#667185',
    medium: '#001234',
    dark: '#000E2A',
    darkest: '#000B1F',
  },
  secondary: {
    lightest: '#FCE8EB',
    light: '#F5A3AF',
    medium: '#E31233',
    dark: '#CE1732',
    darkest: '#6E0C1B',
  },
  neutral: {
    lightest: '#FCFDFC',
    light: '#DBDCDC',
    medium: '#929497',
    dark: '#6D6E70',
    darkest: '#202121',
  },
  success: {
    lightest: '#F5FDD2',
    light: '#D5F477',
    medium: '#A2DD21',
    dark: '#699F10',
    darkest: '#3D6A06',
  },
  info: {
    lightest: '#D6FFFA',
    light: '#85FBFF',
    medium: '#35DAFF',
    dark: '#1A83B7',
    darkest: '#0A437A',
  },
  warning: {
    lightest: '#FFFAD9',
    light: '#FFEE8D',
    medium: '#FFDC42',
    dark: '#B79521',
    darkest: '#7A5D0C',
  },
  error: {
    lightest: '#FFE8D5',
    light: '#FFA981',
    medium: '#FF502D',
    dark: '#B71816',
    darkest: '#7A0818',
  },
  support1: {
    lightest: '#FBFDFC',
    light: '#F8F8F8',
    medium: '#F4F3EE',
    dark: '#C3C2BE',
    darkest: '#92928F',
  },
  support2: {
    lightest: '#CFE7ED',
    light: '#89CDDD',
    medium: '#3F8A97',
    dark: '#307177',
    darkest: '#204C50',
  },
};
